import { renderIcon } from '@videojs/icons/render';
import { createShadowStyle, createTemplate } from '@videojs/utils/dom';

import { SkinElement } from '../skin';

import styles from '../../define/live-video/skin.css?inline';

function getTemplateHTML() {
  return /*html*/ `
    <media-container class="media-default-skin media-default-skin--video">
      <!-- @deprecated slot="media" is no longer required, use the default slot instead -->
      <slot name="media"></slot>
      <slot></slot>

      <media-poster>
        <slot name="poster">
          <img alt="" decoding="async">
        </slot>
      </media-poster>

      <media-buffering-indicator class="media-buffering-indicator">
        ${renderIcon('spinner', { class: 'media-icon' })}
      </media-buffering-indicator>

      <media-error-dialog>
        <media-dialog-backdrop class="media-dialog__backdrop"></media-dialog-backdrop>
        <media-dialog-popup class="media-dialog__popup media-surface">
          <div class="media-dialog__content">
            <media-dialog-title class="media-dialog__title"></media-dialog-title>
            <media-dialog-description class="media-dialog__description"></media-dialog-description>
          </div>
          <div class="media-dialog__actions">
            <media-dialog-close class="media-button media-button--primary"></media-dialog-close>
          </div>
        </media-dialog-popup>
      </media-error-dialog>

      <media-controls>
        <media-controls-backdrop class="media-controls__backdrop"></media-controls-backdrop>
        <media-controls-content class="media-surface media-controls media-controls--root">
          <media-tooltip-group>
            <media-controls-group class="media-surface media-controls media-controls--primary">
              <div class="media-button-group">
                <media-play-button commandfor="play-tooltip" class="media-button media-button--subtle media-button--icon media-button--play">
                  ${renderIcon('restart', { class: 'media-icon media-icon--restart' })}
                  ${renderIcon('play', { class: 'media-icon media-icon--play' })}
                  ${renderIcon('pause', { class: 'media-icon media-icon--pause' })}
                </media-play-button>
                <media-tooltip id="play-tooltip" side="top" class="media-surface media-tooltip">
                  <media-tooltip-label></media-tooltip-label>
                  <media-tooltip-shortcut class="media-tooltip__kbd"></media-tooltip-shortcut>
                </media-tooltip>

                <media-live-button class="media-button media-button--subtle media-button--live"></media-live-button>
              </div>

              <div class="media-time-controls" aria-hidden="true"></div>

              <div class="media-button-group">
                <media-mute-button commandfor="live-video-volume-popover" class="media-button media-button--subtle media-button--icon media-button--mute">
                  ${renderIcon('volume-off', { class: 'media-icon media-icon--volume-off' })}
                  ${renderIcon('volume-low', { class: 'media-icon media-icon--volume-low' })}
                  ${renderIcon('volume-high', { class: 'media-icon media-icon--volume-high' })}
                </media-mute-button>

                <media-popover id="live-video-volume-popover" open-on-hover delay="200" close-delay="100" side="top" class="media-surface media-popover media-popover--volume">
                  <media-volume-slider class="media-slider" orientation="vertical" thumb-alignment="edge">
                    <media-slider-track class="media-slider__track">
                      <media-slider-fill class="media-slider__fill"></media-slider-fill>
                    </media-slider-track>
                    <media-slider-thumb class="media-slider__thumb media-slider__thumb--persistent"></media-slider-thumb>
                  </media-volume-slider>
                </media-popover>

                <media-captions-button menu-for="captions-menu" commandfor="captions-tooltip" class="media-button media-button--subtle media-button--icon media-button--captions">
                  ${renderIcon('captions-off', { class: 'media-icon media-icon--captions-off' })}
                  ${renderIcon('captions-on', { class: 'media-icon media-icon--captions-on' })}
                </media-captions-button>
                <media-menu id="captions-menu" side="top" align="center" class="media-surface media-popover media-menu media-menu--captions">
                  <media-menu-content class="media-menu__content">
                    <media-captions-radio-group class="media-menu__group">
                      <template>
                        <media-menu-radio-item class="media-menu__item">
                          <bdi data-part="label" dir="auto"></bdi>
                          <media-menu-item-indicator force-mount class="media-menu__indicator">
                            ${renderIcon('check', { class: 'media-icon' })}
                          </media-menu-item-indicator>
                        </media-menu-radio-item>
                      </template>
                    </media-captions-radio-group>
                  </media-menu-content>
                </media-menu>
                <media-tooltip id="captions-tooltip" side="top" class="media-surface media-tooltip">
                  <media-tooltip-label></media-tooltip-label>
                  <media-tooltip-shortcut class="media-tooltip__kbd"></media-tooltip-shortcut>
                </media-tooltip>

                <media-cast-button commandfor="cast-tooltip" class="media-button media-button--subtle media-button--icon media-button--cast">
                  ${renderIcon('cast-enter', { class: 'media-icon media-icon--cast-enter' })}
                  ${renderIcon('cast-exit', { class: 'media-icon media-icon--cast-exit' })}
                </media-cast-button>
                <media-tooltip id="cast-tooltip" side="top" class="media-surface media-tooltip">
                  <media-tooltip-label></media-tooltip-label>
                  <media-tooltip-shortcut class="media-tooltip__kbd"></media-tooltip-shortcut>
                </media-tooltip>

                <media-airplay-button commandfor="airplay-tooltip" class="media-button media-button--subtle media-button--icon media-button--airplay">
                  ${renderIcon('airplay-enter', { class: 'media-icon media-icon--airplay-enter' })}
                  ${renderIcon('airplay-exit', { class: 'media-icon media-icon--airplay-exit' })}
                </media-airplay-button>
                <media-tooltip id="airplay-tooltip" side="top" class="media-surface media-tooltip">
                  <media-tooltip-label></media-tooltip-label>
                  <media-tooltip-shortcut class="media-tooltip__kbd"></media-tooltip-shortcut>
                </media-tooltip>

                <media-pip-button commandfor="pip-tooltip" class="media-button media-button--subtle media-button--icon media-button--pip">
                  ${renderIcon('pip-enter', { class: 'media-icon media-icon--pip-enter' })}
                  ${renderIcon('pip-exit', { class: 'media-icon media-icon--pip-exit' })}
                </media-pip-button>
                <media-tooltip id="pip-tooltip" side="top" class="media-surface media-tooltip">
                  <media-tooltip-label></media-tooltip-label>
                  <media-tooltip-shortcut class="media-tooltip__kbd"></media-tooltip-shortcut>
                </media-tooltip>

                <media-fullscreen-button commandfor="fullscreen-tooltip" class="media-button media-button--subtle media-button--icon media-button--fullscreen">
                  ${renderIcon('fullscreen-enter', { class: 'media-icon media-icon--fullscreen-enter' })}
                  ${renderIcon('fullscreen-exit', { class: 'media-icon media-icon--fullscreen-exit' })}
                </media-fullscreen-button>
                <media-tooltip id="fullscreen-tooltip" side="top" class="media-surface media-tooltip">
                  <media-tooltip-label></media-tooltip-label>
                  <media-tooltip-shortcut class="media-tooltip__kbd"></media-tooltip-shortcut>
                </media-tooltip>

              </div>
            </media-controls-group>
          </media-tooltip-group>
        </media-controls-content>
      </media-controls>

      <!-- Hotkeys -->
      <media-hotkey keys="Space" action="togglePaused"></media-hotkey>
      <media-hotkey keys="k" action="togglePaused"></media-hotkey>
      <media-hotkey keys="m" action="toggleMuted"></media-hotkey>
      <media-hotkey keys="f" action="toggleFullscreen"></media-hotkey>
      <media-hotkey keys="c" action="toggleSubtitles"></media-hotkey>
      <media-hotkey keys="i" action="togglePictureInPicture"></media-hotkey>
      <media-hotkey keys="ArrowUp" action="volumeStep" value="0.05"></media-hotkey>
      <media-hotkey keys="ArrowDown" action="volumeStep" value="-0.05"></media-hotkey>

      <!-- Gestures -->
      <media-gesture type="tap" action="togglePaused" pointer="mouse" region="center"></media-gesture>
      <media-gesture type="tap" action="toggleControls" pointer="touch"></media-gesture>
      <media-gesture type="doubletap" action="toggleFullscreen" region="center"></media-gesture>

      <!-- Input Indicators -->
      <media-status-announcer class="media-sr-only"></media-status-announcer>
      <div class="media-input-indicator">
        <media-volume-indicator hidden class="media-surface media-volume-indicator">
          <media-volume-indicator-fill class="media-volume-indicator__content">
            ${renderIcon('volume-high', { class: 'media-icon media-icon--volume-high' })}
            ${renderIcon('volume-low', { class: 'media-icon media-icon--volume-low' })}
            ${renderIcon('volume-off', { class: 'media-icon media-icon--volume-off' })}
            <media-volume-indicator-value class="media-volume-indicator__value"></media-volume-indicator-value>
          </media-volume-indicator-fill>
        </media-volume-indicator>
        <media-status-indicator
          hidden
          actions="toggleSubtitles toggleFullscreen togglePictureInPicture"
          class="media-surface media-status-indicator media-status-indicator--state"
        >
          <div class="media-status-indicator__content">
            ${renderIcon('captions-on', { class: 'media-icon media-icon--captions-on' })}
            ${renderIcon('captions-off', { class: 'media-icon media-icon--captions-off' })}
            ${renderIcon('fullscreen-enter', { class: 'media-icon media-icon--fullscreen-enter' })}
            ${renderIcon('fullscreen-exit', { class: 'media-icon media-icon--fullscreen-exit' })}
            ${renderIcon('pip-enter', { class: 'media-icon media-icon--pip-enter' })}
            ${renderIcon('pip-exit', { class: 'media-icon media-icon--pip-exit' })}
            <media-status-indicator-value class="media-status-indicator__value"></media-status-indicator-value>
          </div>
        </media-status-indicator>
        <media-status-indicator hidden actions="togglePaused" class="media-status-indicator media-status-indicator--playback">
          ${renderIcon('play', { class: 'media-icon media-icon--play' })}
          ${renderIcon('pause', { class: 'media-icon media-icon--pause' })}
        </media-status-indicator>
      </div>
    </media-container>
  `;
}

export class LiveVideoSkinElement extends SkinElement {
  static readonly tagName = 'live-video-skin';
  static styles = createShadowStyle(styles);
  static template = createTemplate(getTemplateHTML());
}

declare global {
  interface HTMLElementTagNameMap {
    [LiveVideoSkinElement.tagName]: LiveVideoSkinElement;
  }
}
